'use client';

import { BUContext } from '@/utils/contexts/BusinessUnitContext';
import useLanguage from '@/utils/hooks/useLanguage';
import { onStart } from '@/utils/helpers/navigation';
import Link, { LinkProps } from 'next/link';
import { useContext, useMemo } from 'react';
import { usePathname } from 'next/navigation';

interface CustomLinkProps extends LinkProps {
	children: React.ReactNode | string;
	className?: string;
	noProgress?: boolean;
}

export function CustomLink({ href, noProgress, ...rest }: Readonly<CustomLinkProps>) {
	const { currentLocale } = useLanguage();
	const pathname = usePathname();

	const bu = useContext(BUContext);

	const mappedHref = useMemo(() => {
		if (href.toString().includes('/manage')) {
			return `/${currentLocale}${href}`;
		}

		return `/${currentLocale}/${bu}${href === '/' ? '' : href}`;
	}, [href, currentLocale, bu]);

	return (
		<Link
			href={mappedHref}
			{...rest}
			onClick={(e) => {
				!noProgress && onStart(mappedHref, pathname);
				rest.onClick?.(e);
			}}
		>
			{rest.children}
		</Link>
	);
}

export default CustomLink;
